<template>
    <div class="result-container">
        <div class="container">
            <div class="result result-check" v-if="showResultPart == 'check'" :class="analyseClass">
                <div class="result__title">Pourcentage de votre CA prévisionnel</div>
                <div class="result__amount-container">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :width="svgCircleRadius * 2" :height="svgCircleRadius * 2" :viewbox="viewbox" x="0" y="0">
                        <circle :r="svgCircleRadius" :cx="svgCircleRadius" :cy="svgCircleRadius" :style="{ 'stroke-dasharray': strokeDashArray}"></circle>
                    </svg>
                    <div class="result__amount">{{ result }} %</div>
                </div>
                <p v-text="analyse"></p>
            </div>
            <div class="result result-calculation" v-if="showResultPart == 'calculation'">
                <div class="result__title">Votre budget de communication</div>
                <div class="result__amount-container">

                    <div class="result__amount">{{ result }} €</div>
                </div>

                <p>Ce montant est calculé sur une base de 6% de votre CA prévisionnel. Il peut être supérieur en cas de lancement. Un investissement inférieur à 4% ne serait pas suffisant</p>
            </div>
            <button class="btn btn-lg btn-primary" @click="close">Retour</button>
        </div>
    </div>
</template>

<script>
    import { eventBus } from '../../main';

    export default {
        data() {
            return {
                svgCircleRadius: 80,
                viewbox: '',
                strokeDashArrayCircumference: '',
                strokeDashArray: ''
            }
        },
        computed: {
            analyse() {
                return this.$store.state.budget.analyse;
            },
            analyseClass() {
                return this.$store.state.budget.analyseClass;
            },
            showResultPart() {
                return this.$store.state.budget.showResultPart;
            },
            result() {
                return this.$store.state.budget.result;
            }
        },
        methods: {
            close() {
                this.$store.commit('hideBudgetResult');
            },
        },
        created() {
            this.viewbox = '0 0 '+this.svgCircleRadius * 2+' '+this.svgCircleRadius * 2;
            this.strokeDashArrayCircumference = this.svgCircleRadius * (Math.PI * 2);
            this.strokeDashArray = (this.result * this.strokeDashArrayCircumference / 100)+' '+this.strokeDashArrayCircumference;
        },
    }
</script>


// WEBPACK FOOTER //
// Result.vue?a38e45e0